// extracted by mini-css-extract-plugin
export default {"header":"offer_header__Q963n"};